// The legal and trust pages, rendered by pages/LegalPage.jsx. These are the URLs given to
// Google (OAuth consent screen, Google Play), Apple (App Store Connect) and Salesforce
// (AppExchange listing): keep the paths stable. Bump `updated` when a policy's text changes.
// The texts are in ./content.js, which only LegalPage's lazy chunk imports, so the footer's
// links don't pull them into the main bundle.
// Headings use *asterisks* for the italic serif accent.
export const legalPages = [
  {
    slug: 'privacy',
    path: '/privacy',
    label: 'Privacy Policy',
    title: 'Privacy *policy*',
    lede: 'What we collect, why, who we share it with, and the choices and rights you have.',
    updated: '10 October 2026'
  },
  {
    slug: 'terms',
    path: '/terms',
    label: 'Terms of Service',
    title: 'Terms of *service*',
    lede: 'The rules for using our website, apps and AppExchange products.',
    updated: '10 October 2026'
  },
  {
    slug: 'cookies',
    path: '/cookies',
    label: 'Cookie Policy',
    title: 'Cookie *policy*',
    lede: 'The few cookies and storage items this website uses, and how to turn analytics off.',
    updated: '10 October 2026'
  },
  {
    slug: 'security',
    path: '/security',
    label: 'Security',
    title: 'Security at *Dreamvision*',
    lede: 'How we protect data in the products we build, and how to report a vulnerability.',
    updated: '10 October 2026'
  },
  {
    slug: 'support',
    path: '/support',
    label: 'Support',
    title: 'How can we *help?*',
    lede: 'Help with our apps, AppExchange products and client projects.',
    updated: '10 October 2026'
  },
  {
    slug: 'data-deletion',
    path: '/data-deletion',
    label: 'Data Deletion',
    title: 'Delete your *data*',
    lede: 'How to delete your account and personal information, and what happens next.',
    updated: '10 October 2026'
  }
];

export const legalBySlug = Object.fromEntries(legalPages.map(p => [p.slug, p]));
